import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

/**
 * Layout route for /profile/settings and all its sub-routes.
 * Renders <Outlet /> so children (index, /tags, /user-type, /shareable-link)
 * are mounted into this slot.
 * Auth guard lives here so every child inherits the check.
 */
export const Route = createFileRoute('/profile/settings')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: () => <Outlet />,
});
